var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-change-button-body",on:{"click":_vm.changeTheme}},[_c('div',{ref:"themeChangeButtonImage",staticClass:"theme-change-button-bg-dark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }